import React from "react";
import { AlertTriangle } from "lucide-react";

export default function Disclaimer() {
  return (
    <section
      className="relative py-20 bg-[#070e26] border-y border-white/5"
      data-testid="disclaimer-section"
      aria-label="Yasal uyarı"
    >
      <div className="max-w-5xl mx-auto px-6 md:px-10 lg:px-16">
        <div
          className="relative glass-card rounded-2xl p-8 md:p-12 overflow-hidden"
          data-testid="disclaimer-card"
        >
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#d4af37] to-transparent" />

          <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-start">
            <div className="shrink-0">
              <div className="w-14 h-14 rounded-full border border-[#d4af37]/40 flex items-center justify-center bg-[#d4af37]/5">
                <AlertTriangle size={22} className="text-[#d4af37]" />
              </div>
            </div>
            <div className="flex-1">
              <div
                className="text-[11px] tracking-[0.3em] uppercase text-[#d4af37] mb-3"
                data-testid="disclaimer-eyebrow"
              >
                Önemli Yasal Uyarı
              </div>
              <h3
                className="font-serif text-2xl md:text-3xl text-white leading-snug"
                data-testid="disclaimer-title"
              >
                Burada yer alan bilgiler{" "}
                <span className="italic text-gold-gradient">
                  yatırım tavsiyesi değildir.
                </span>
              </h3>
              <p
                className="mt-5 text-[#cbd5e1] text-base md:text-[17px] font-light leading-relaxed"
                data-testid="disclaimer-body"
              >
                Bu sitede yer alan bilgi, yorum ve analizler{" "}
                <span className="text-white">yatırım tavsiyesi değildir</span>.
                Finansal piyasalarda işlem yapmak risk içerir. Paylaşılan
                içerikler genel bilgilendirme amacı taşır. Yatırım kararlarınızı
                kendi araştırmanız ve risk profiliniz doğrultusunda vermelisiniz.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
